import React from "react";
import "./TextArea.scss";
import TextAreaProps from "./TextArea.types";

const TextArea = (props: TextAreaProps) => {
  const { label, placeholder, required, className, borderColor, rows } = props;
  return (
    <div className="container">
      <label className="fw-600"> {label}</label>
      <textarea
        placeholder={placeholder}
        rows={props.rows && props.rows}
        {...props}
        className={
          borderColor === "danger"
            ? "border-danger"
            : borderColor === "default"
            ? "border-default"
            : "border-primary"
        }
      ></textarea>
    </div>
  );
};

export default TextArea;
